// File: utils/format.js
//
// Small formatting helpers used in multiple places.

// Turns a Firestore timestamp (or a plain Date) into a short label
// like "Mar 5" for showing next to a message thread in the list.
// If there's no date, returns an empty string so we don't print "undefined".
export function formatThreadTime(updatedAt) {
  const d =
    updatedAt?.toDate?.() || (updatedAt instanceof Date ? updatedAt : null);
  if (!d) return "";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
